'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var React = require('react');
var mergeRefs = require('react-merge-refs');
var cn = require('classnames');
var coreComponentsMq = require('@alfalab/core-components-mq');
var coreComponentsScrollbar = require('@alfalab/core-components-scrollbar');
var coreComponentsShared = require('@alfalab/core-components-shared');
var consts = require('../../consts.js');
var utils = require('../../utils.js');
var components_optgroup_Component = require('../optgroup/Component.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefaultCompat(React);
var mergeRefs__default = /*#__PURE__*/_interopDefaultCompat(mergeRefs);
var cn__default = /*#__PURE__*/_interopDefaultCompat(cn);

var styles = {"optionsList":"select__optionsList_7309k","optionsListHeader":"select__optionsListHeader_7309k","headerHighlighted":"select__headerHighlighted_7309k","optionsListFooter":"select__optionsListFooter_7309k","withBorder":"select__withBorder_7309k","scrollable":"select__scrollable_7309k","-webkit-mask":"select__mask_7309k","mask":"select__mask_7309k","emptyPlaceholder":"select__emptyPlaceholder_7309k","size-64":"select__size-64_7309k","size-72":"select__size-72_7309k"};
require('./index.css')

var createCounter = function () {
    var count = 0;
    // eslint-disable-next-line no-plusplus
    return function () { return count++; };
};
var OptionsList = React.forwardRef(function (_a, ref) {
    var _b, _c;
    var _d = _a.size, size = _d === void 0 ? 48 : _d, className = _a.className, optionGroupClassName = _a.optionGroupClassName, scrollbarClassName = _a.scrollbarClassName, Option = _a.Option, getOptionProps = _a.getOptionProps, _e = _a.groupOptionProps, groupOptionProps = _e === void 0 ? {} : _e, _f = _a.options, options = _f === void 0 ? [] : _f, _g = _a.Optgroup, Optgroup = _g === void 0 ? components_optgroup_Component.Optgroup : _g, dataTestId = _a.dataTestId, emptyPlaceholder = _a.emptyPlaceholder, _h = _a.visibleOptions, visibleOptions = _h === void 0 ? consts.DEFAULT_VISIBLE_OPTIONS : _h, onScroll = _a.onScroll, open = _a.open, header = _a.header, footer = _a.footer, _j = _a.showFooter, showFooter = _j === void 0 ? true : _j, optionsListWidth = _a.optionsListWidth, nativeScrollbarProp = _a.nativeScrollbar, _k = _a.flatOptions, flatOptions = _k === void 0 ? [] : _k, setHighlightedIndex = _a.setHighlightedIndex, selectedItems = _a.selectedItems, search = _a.search, setSelectedItems = _a.setSelectedItems, multiple = _a.multiple, _l = _a.limitDynamicOptionGroupSize, limitDynamicOptionGroupSize = _l === void 0 ? false : _l;
    var _m = React.useState(true), scrollTop = _m[0], setScrollTop = _m[1];
    var _o = React.useState(false), scrollBottom = _o[0], setScrollBottom = _o[1];
    var query = '(max-width: 1023px)';
    var nativeScrollbar = coreComponentsMq.useMatchMedia(query, function () {
        return coreComponentsShared.isClient() ? window.matchMedia(query).matches : true;
    })[0];
    nativeScrollbar = Boolean(nativeScrollbarProp !== null && nativeScrollbarProp !== void 0 ? nativeScrollbarProp : nativeScrollbar);
    var handleScroll = React.useCallback(function (event) {
        var scrolledToHeader = event.currentTarget.scrollTop <= 0;
        var scrolledToFooter = event.currentTarget.scrollHeight - event.currentTarget.offsetHeight <=
            event.currentTarget.scrollTop;
        setScrollTop(scrolledToHeader);
        setScrollBottom(scrolledToFooter);
        onScroll === null || onScroll === void 0 ? void 0 : onScroll(event);
    }, [onScroll]);
    var renderOption = function (option, index) { return (React__default.default.createElement(Option, tslib.__assign({ key: option.key }, getOptionProps(option, index)))); };
    var listRef = React.useRef(null);
    var scrollbarRef = React.useRef(null);
    var counter = createCounter();
    var renderGroup = function (group) {
        var groupSelectedItems = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(function (_a) {
            var selectedItemKey = _a.key;
            return group.options.some(function (option) { return option.key === selectedItemKey; });
        });
        var handleSelectedItems = function (items) {
            var _a;
            setSelectedItems(((_a = selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(function (_a) {
                var selectedItemKey = _a.key;
                return !group.options.some(function (option) { return option.key === selectedItemKey; });
            })) !== null && _a !== void 0 ? _a : []).concat(items));
        };
        return (React__default.default.createElement(Optgroup, tslib.__assign({ className: optionGroupClassName, label: group.label, key: group.label, size: size, options: group.options, selectedItems: groupSelectedItems, setSelectedItems: handleSelectedItems, search: search, multiple: multiple }, groupOptionProps), group.options.map(function (option) { return renderOption(option, counter()); })));
    };
    var actualOptionsCount = limitDynamicOptionGroupSize && options.length > 0;
    var measured = utils.useVisibleOptions(tslib.__assign(tslib.__assign({}, (!nativeScrollbar && { styleTargetRef: scrollbarRef })), { visibleOptions: visibleOptions, listRef: listRef, open: open, options: options, actualOptionsCount: actualOptionsCount, size: actualOptionsCount
            ? (function () {
                switch (typeof size) {
                    case 'string':
                        throw new Error('OptionsList with `limitDynamicOptionGroupSize` enabled needs a `size` with number type');
                    default:
                        return size;
                }
            })()
            : undefined }));
    if (options.length === 0 && !emptyPlaceholder && !header && !footer) {
        return null;
    }
    var renderListItems = function () { return (React__default.default.createElement(React__default.default.Fragment, null,
        options.map(function (option) {
            return utils.isGroup(option) ? renderGroup(option) : renderOption(option, counter());
        }),
        emptyPlaceholder && options.length === 0 && (React__default.default.createElement("div", { className: styles.emptyPlaceholder }, emptyPlaceholder)))); };
    var renderWithCustomScrollbar = function () {
        var scrollableNodeProps = {
            onScroll: handleScroll,
            'data-test-id': dataTestId,
            ref: ref,
        };
        return (React__default.default.createElement(coreComponentsScrollbar.Scrollbar, { className: cn__default.default(styles.scrollable, scrollbarClassName), ref: scrollbarRef, horizontalAutoStretch: optionsListWidth === 'content', scrollableNodeProps: scrollableNodeProps, contentNodeProps: { ref: listRef }, maskProps: { className: measured ? undefined : styles.mask } }, renderListItems()));
    };
    var renderWithNativeScrollbar = function () { return (React__default.default.createElement("div", { className: cn__default.default(styles.scrollable, scrollbarClassName), ref: mergeRefs__default.default([listRef, ref]), onScroll: handleScroll }, renderListItems())); };
    var resetHighlightedIndex = function () { return setHighlightedIndex === null || setHighlightedIndex === void 0 ? void 0 : setHighlightedIndex(-1); };
    return (React__default.default.createElement("div", tslib.__assign({}, (nativeScrollbar && { 'data-test-id': dataTestId }), { className: cn__default.default(styles.optionsList, styles[consts.SIZE_TO_CLASSNAME_MAP[size]], className) }),
        header && (React__default.default.createElement("div", { className: cn__default.default(styles.optionsListHeader, (_b = {},
                _b[styles.headerHighlighted] = !scrollTop,
                _b)), onMouseEnter: resetHighlightedIndex }, header)),
        nativeScrollbar ? renderWithNativeScrollbar() : renderWithCustomScrollbar(),
        showFooter && footer && (React__default.default.createElement("div", { onMouseEnter: resetHighlightedIndex, className: cn__default.default(styles.optionsListFooter, (_c = {},
                _c[styles.withBorder] = visibleOptions &&
                    flatOptions.length > visibleOptions &&
                    !scrollBottom,
                _c)) }, footer))));
});

exports.OptionsList = OptionsList;
